import React from 'react';
import PropTypes from 'prop-types';
import { WebsiteListSelector } from '@bingads-webui-campaign-react/website-list-selector';

export const WebsiteLists = ({
  selectedExclusions = [],
  onExclusionsChange = () => {},
}) => (
  <WebsiteListSelector
    listType="block"
    selected={selectedExclusions}
    onChange={onExclusionsChange}
  />
);

WebsiteLists.propTypes = {
  selectedExclusions: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.string.isRequired,
  })),
  onExclusionsChange: PropTypes.func,
};

WebsiteLists.defaultProps = {
  selectedExclusions: [],
  onExclusionsChange: () => {},
};
